import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Hero17 from '../components/hero17'
import Banner1 from '../components/banner1'
import Features24 from '../components/features24'
import CTA26 from '../components/cta26'
import Steps2 from '../components/steps2'
import Testimonial17 from '../components/testimonial17'
import Contact10 from '../components/contact10'
import Footer4 from '../components/footer4'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Allstream Global Business Solutions</title>
        <meta
          name="description"
          content='"Streamline your business with Allstream – expert Business Setup, HR, Finance, IT, and Admin support for fast, hassle-free growth."'
        />
        <meta
          property="og:title"
          content="Allstream Global Business Solutions"
        />
        <meta
          property="og:description"
          content='"Streamline your business with Allstream – expert Business Setup, HR, Finance, IT, and Admin support for fast, hassle-free growth."'
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/231f249b-b608-4355-8168-0f58a5abbd5a/0c40ed70-952b-4901-8fa3-40ab70c3e200?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="home-text10">#About Us</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text11">#Why Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text12">#</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text13">#</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="home-text14">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="home-text15">About Us</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="home-text16">Services</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="home-text17">Contact</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="home-text18">Contact Us</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text19">Secondary Action</span>
          </Fragment>
        }
        logoSrc="/logo-1500h.png"
        link1Url="/"
        page1Description={
          <Fragment>
            <span className="home-text20">Page One Description</span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="home-text21">Page Two Description</span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="home-text22">Page Three Description</span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="home-text23">Page Four Description</span>
          </Fragment>
        }
      ></Navbar8>
      <Hero17
        action1={
          <Fragment>
            <span className="home-text24">Get Started</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text25">Learn More</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text26">
              <span>
                We simplify your startup journey—company formation, licensing,
                visas, PRO, and back-office solutions—so you can focus on
                growing your business.
              </span>
              <br></br>
              <br></br>
              <span>
                We will provide end-to-end support to startups looking to
                establish their presence in Abu Dhabi. From setting up your
                trade license to handling administrative tasks, we&apos;ve got
                you covered.
              </span>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text31">
              Launch Your Startup in Abu Dhabi with Ease: Hassle-Free Business
              Setup + BPO Support
            </span>
          </Fragment>
        }
        image1Src="/1-1500w.jpg"
        image2Src="/2-1500w.png"
        image3Src="/3-1500w.jpeg"
      ></Hero17>
      <Banner1
        text={
          <Fragment>
            <span className="home-text32">
              {' '}
              At Allstream Global, we don’t just help you start a company — we
              help you run it smarter, leaner, and more profitably. Our mission
              is to simplify business operations in the UAE so entrepreneurs,
              SMEs, and international companies can focus on growth, not
              paperwork.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="home-text33">
              {' '}
              Work With Us
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="home-text34">
              <span>
                {' '}
                Founded by a team of business operations experts, Allstream
                Global Business Solutions was created to bridge the gap between
                complex administrative tasks and seamless business growth.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                {' '}
                We’ve helped various companies streamline HR, finance,
                procurement, IT, and compliance — all under one roof.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="home-text38">
              {' '}
              To empower businesses in the UAE with expert administrative
              support so they can focus on what matters most: growth,
              innovation, and profitability.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="home-text39">
              {' '}
              To become the most trusted partner for businesses in the UAE,
              offering a one-stop solution for operations, compliance, HR,
              finance, procurement, IT, and PRO services.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="home-text40">
              We maintain transparency and honesty in all our operations and
              interactions.
            </span>
          </Fragment>
        }
        text6={
          <Fragment>
            <span className="home-text41">
              We aim for the highest standards in service, performance, and
              client satisfaction.
            </span>
          </Fragment>
        }
        text7={
          <Fragment>
            <span className="home-text42">
              We continuously improve processes to make business management
              smarter and more efficient.
            </span>
          </Fragment>
        }
        text8={
          <Fragment>
            <span className="home-text43">
              We put our clients’ needs at the center of everything we do,
              providing personalized solutions.
            </span>
          </Fragment>
        }
        heading={
          <Fragment>
            <span className="home-text44">About Allstream Global</span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="home-text45">Our Core Values</span>
          </Fragment>
        }
        heading3={
          <Fragment>
            <span className="home-text46">Our Story</span>
          </Fragment>
        }
        heading4={
          <Fragment>
            <span className="home-text47">Our Mission</span>
          </Fragment>
        }
        heading5={
          <Fragment>
            <span className="home-text48">Our Vision</span>
          </Fragment>
        }
        heading6={
          <Fragment>
            <span className="home-text49">Integrity</span>
          </Fragment>
        }
        heading7={
          <Fragment>
            <span className="home-text50">Excellence</span>
          </Fragment>
        }
        heading8={
          <Fragment>
            <span className="home-text51">Innovation</span>
          </Fragment>
        }
        heading9={
          <Fragment>
            <span className="home-text52">Client Focus</span>
          </Fragment>
        }
      ></Banner1>
      <Features24
        feature1Title={
          <Fragment>
            <span className="home-text53">
              <span>Trade License Setup</span>
              <br></br>
            </span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text56">Outsourcing Admin Tasks</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text57">Mainland or Free Zone Options</span>
          </Fragment>
        }
        feature1ImgSrc="/abu%20dhbai-1400w.jpeg"
        feature1Description={
          <Fragment>
            <span className="home-text58">
              We assist in obtaining the necessary trade license for your
              startup in Abu Dhabi.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text59">
              Delegate tasks like PRO, HR, Accounts, IT, and website creation to
              our team of experts.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text60">
              Choose between setting up your startup in the Abu Dhabi mainland
              or a free zone with our guidance.
            </span>
          </Fragment>
        }
      ></Features24>
      <CTA26
        action1={
          <Fragment>
            <span className="home-text61">Get Started Now</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text62">
              Let us handle the setup process and administrative tasks for you.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text63">
              Ready to Launch Your Startup in Abu Dhabi?
            </span>
          </Fragment>
        }
      ></CTA26>
      <Steps2
        step1Title={
          <Fragment>
            <span className="home-text64">Initial Consultation</span>
          </Fragment>
        }
        step2Title={
          <Fragment>
            <span className="home-text65">Trade License Setup</span>
          </Fragment>
        }
        step3Title={
          <Fragment>
            <span className="home-text66">Office Space Solutions</span>
          </Fragment>
        }
        step4Title={
          <Fragment>
            <span className="home-text67">Select Services</span>
          </Fragment>
        }
        step3Title1={
          <Fragment>
            <span className="home-text68">Get Started</span>
          </Fragment>
        }
        step1Description={
          <Fragment>
            <span className="home-text69">
              Schedule a consultation with our team to discuss your business
              goals and requirements.
            </span>
          </Fragment>
        }
        step2Description={
          <Fragment>
            <span className="home-text70">
              We will assist you in obtaining the necessary trade license for
              your startup in Abu Dhabi.
            </span>
          </Fragment>
        }
        step3Description={
          <Fragment>
            <span className="home-text71">
              Explore our office space options tailored to meet the needs of
              your growing business.
            </span>
          </Fragment>
        }
        step4Description={
          <Fragment>
            <span className="home-text72">
              Choose the services you need assistance with, such as PRO, HR,
              Accounts, IT, and website creation.
            </span>
          </Fragment>
        }
        step3Description1={
          <Fragment>
            <span className="home-text73">
              Let us handle the setup process and support services while you
              focus on launching and growing your business.
            </span>
          </Fragment>
        }
      ></Steps2>
      <Testimonial17
        review1={
          <Fragment>
            <span className="home-text74">
              Working with the team made setting up our business in Abu Dhabi a
              breeze. They took care of all the paperwork efficiently.
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text75">
              I highly recommend their BPO support services. It allowed us to
              focus on growing our business while they handled the day-to-day
              tasks.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text76">
              The team provided valuable insights and guidance throughout the
              setup process. Their expertise was invaluable.
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text77">
              We couldn&apos;t have asked for better support in establishing our
              presence in Abu Dhabi. They exceeded our expectations.
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text78">
              Working with Allstream Global Business Solutions was a
              game-changer for our startup. Their efficient services allowed us
              to focus on our core business activities and accelerate our
              growth.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text79">Testimonials</span>
          </Fragment>
        }
        author1Name={
          <Fragment>
            <span className="home-text80">John Doe</span>
          </Fragment>
        }
        author2Name={
          <Fragment>
            <span className="home-text81">Jane Smith</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text82">David Lee</span>
          </Fragment>
        }
        author4Name={
          <Fragment>
            <span className="home-text83">Sarah Johnson</span>
          </Fragment>
        }
        author1Position={
          <Fragment>
            <span className="home-text84">CEO, Tech Startup X</span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text85">Founder, E-commerce Company Y</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text86">COO, Software Solutions Z</span>
          </Fragment>
        }
        author4Position={
          <Fragment>
            <span className="home-text87">CTO, AI Startup W</span>
          </Fragment>
        }
      ></Testimonial17>
      <Contact10
        content1={
          <Fragment>
            <span className="home-text88">
              Have questions or ready to get started? Reach out to us for more
              information.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text89">Contact Us</span>
          </Fragment>
        }
      ></Contact10>
      <Footer4
        link1={
          <Fragment>
            <span className="home-text90">About Us</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text91">Services</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text92">Contact US</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text93">DEI Policy</span>
          </Fragment>
        }
        termsLink={
          <Fragment>
            <span className="home-text94">Terms of Service</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span className="home-text95">Cookies Settings</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="home-text96">Privacy Policy</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default Home
